import React from 'react';
import { Outlet } from 'react-router-dom';
import { getText } from '@storebrand-digital/fms-translations';
import { Button } from '@storeblocks/button';
import { MessageChat } from './styled';
function Compose() {
    var onChatStart = function () {
        if (window.chatPanel) {
            window.chatPanel.show();
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(MessageChat, null,
            React.createElement("div", { className: "label" }, getText('message.chat.title')),
            React.createElement("p", null, getText('message.chat.description')),
            React.createElement(Button, { variant: "outlined", iconRight: "arrow-right", onClick: onChatStart }, getText('message.chat.start.label'))),
        React.createElement(Outlet, null)));
}
export default Compose;
